import type { MappedNotification } from 'common/header/notifications/Notifications.types';

export const getIconType = ({
  isCancelled,
  isError,
  isReady,
  inProgress,
  isQueued
}: {
  isCancelled: boolean;
  isError: boolean;
  isReady: boolean;
  inProgress: boolean;
  isQueued: boolean;
}): MappedNotification['iconType'] => {
  if (isError) {
    return 'FAILURE';
  }
  if (isCancelled) {
    return 'CANCELLED';
  }

  if (isQueued) {
    return 'IS_QUEUED';
  }

  if (inProgress) {
    return 'IN_PROGRESS';
  }
  return isReady ? 'SUCCESS' : 'INFO';
};
